import { render, staticRenderFns } from "./BankAktivitas.vue?vue&type=template&id=6a9d0b7a&scoped=true&lang=html&"
import script from "./BankAktivitas.vue?vue&type=script&lang=js&"
export * from "./BankAktivitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d0b7a",
  null
  
)

export default component.exports